import { render, staticRenderFns } from "./fragmingamShow.vue?vue&type=template&id=563e6459&"
import script from "./fragmingamShow.vue?vue&type=script&lang=js&"
export * from "./fragmingamShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports